<template>
    <NUIButton
      :obj="this.clear"
      :displayType="'icon'"
    />
</template>

<script>

import NUIButton from '../../nelsonUI/NUIButton.vue';
import { useSegmentStore } from '../../../store/SegmentStore';
import { useModalStore } from '../../../store/ModalStore';

export default {
  data () {
    return {
      clear: {
        label: 'Clear',
        icon: 'remove_btn',
        value: 'print',
        orientation: 'top',
        marker: 'var(--nelson-green)',
        func: this.handleClear,
      }
    };
  },
  methods: {
    handleClear () {
      useModalStore().setModalObj({
        promptLabel: 'Clear All Pipes and Slopes',
        promptDescription: 'Clear all pipes and slopes?',
        buttonALabel: 'Yes',
        buttonAFunc: this.clearPipesAndSlopes,
        buttonBLabel: 'Cancel',
        buttonBFunc: this.handleModalCancel
      });
      useModalStore().showModal('prompt');
    },
    clearPipesAndSlopes () {
      useSegmentStore().clearPipesAndSlopes();
      this.handleModalCancel();
    },
    handleModalCancel () {
      useModalStore().hideModal();
    }
  },
  components: {
    NUIButton
  },

};
</script>

<style scoped>
.calculations-button {
  width: 100px;
  background-color: yellowgreen;
  cursor: pointer;
}
</style>